const ResponseStatus = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  NOT_USER: 403,
  NOT_FOUND: 404,
  MORE_ONE_EMPLOYEE: 406,
  CONFLICT: 409,
  SERVER_ERROR: 500,
  SYSTEM_ERROR: 502,
};

// 201 es éxito: sin él, el POST de solicitudes de modificación (201 Created)
// caía al catch y el modal se quedaba abierto con la solicitud ya creada.
const HTTP_SUCCESS_STATUS = [
  ResponseStatus.OK,
  ResponseStatus.CREATED,
  ResponseStatus.NO_CONTENT,
];

export { HTTP_SUCCESS_STATUS, ResponseStatus };
